"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _useForkRef = _interopRequireDefault(require("@material-ui/core/utils/useForkRef"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const handleResize = onResize => {
  if (typeof window !== undefined) {
    const {
      innerWidth,
      innerHeight
    } = window;
    onResize({
      innerWidth,
      innerHeight
    });
  }
};
const ResizeListener = ({
  onResize,
  debounceWait,
  children,
  direction
}) => {
  const nodeRef = (0, _react.useRef)(null);
  const handleRef = (0, _useForkRef.default)(children.ref, nodeRef);
  const childrenProps = {
    ref: handleRef
  };
  const [currentSize, setCurrentSize] = (0, _react.useState)({
    width: 0,
    height: 0
  });
  (0, _react.useEffect)(() => {
    const debouncedCallback = (0, _debounce.default)(() => {
      const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      const height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      if (!direction) {
        handleResize(onResize);
      } else if (direction === 'height' && currentSize.height !== height) {
        handleResize(onResize);
      } else if (direction === 'width' && currentSize.width !== width) {
        handleResize(onResize);
      }
      setCurrentSize({
        width,
        height
      });
    }, debounceWait);
    window.addEventListener('resize', debouncedCallback);
    return () => window.removeEventListener('resize', debouncedCallback);
  }, [debounceWait, currentSize, direction]); // no funcs

  (0, _react.useEffect)(() => handleResize(onResize), []); // no funcs

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.cloneElement(children, childrenProps));
};
ResizeListener.propTypes = {
  direction: _propTypes.default.oneOf(['height', 'width']),
  onResize: _propTypes.default.func,
  debounceWait: _propTypes.default.number,
  children: _propTypes.default.node
};
ResizeListener.defaultProps = {
  onResize: () => null,
  debounceWait: 20,
  children: null,
  direction: null
};
var _default = exports.default = ResizeListener;